<script lang="ts">

    import { Component, Prop, Vue } from "vue-facing-decorator";
    import IconComponent from "@/components/atoms/Icon.vue";
    import { ArtistSearchResult } from "webshop-api";
    import { AnalyticsEventName,
        AnalyticsEventStructureProvider,
        GTMUtils, IconName, ItemListData, TranslationKey, TranslationService } from "webshop-modules";
    import { AnalyticsItemsProvider } from "@/domain/search/entitites/AnalyticsItemsProvider";
    import { StringUtilities } from "webshop-modules/string/String.utilities";

    @Component({
        components: {
            IconComponent
        }
    })
    export default class ArtistComponent extends Vue {

        @Prop()
        public readonly item!: ArtistSearchResult;

        public readonly IconName: typeof IconName = IconName;

        public readonly Translation: typeof TranslationKey = TranslationKey;

        public lang: string = TranslationService.getCountryCode() === 'en'
            ? 'en'
            : 'lc';

        public staticUrl: string | null =  document.querySelector('body')!.getAttribute('data-static');

        public stripTags(title: string) {
            return StringUtilities.stripTags(title);
        }

        public handleSelectArtist() {
          const eventData = {
            event: AnalyticsEventName.SelectItem,
            ecommerce: {
              item_list_name: this.item.title || '-',
              item_list_id: this.item.title || '-',
              items: AnalyticsItemsProvider.setupAnalyticsArtistItems([this.item]).map(item => AnalyticsEventStructureProvider.getTicketItem(item)),
            }
          };

          GTMUtils.pushGA4EcommerceToDataLayer<ItemListData>(eventData);
        }

    }
</script>

<template>
    <li>
        <a  v-if="item.title"
                :href="item.url"
                class="m-searchListItem"
                data-qa="search-list-item"
                v-on:click="handleSelectArtist">
            <div class="m-searchListItem__block">
                <div class="a-badgeThumb" >
                    <picture v-if="item.image" class="a-picture -with-ratio" style="padding-bottom: 100%;">
                        <img :src="staticUrl+item.image" alt="">
                    </picture>
                    <picture v-else class="a-picture -with-ratio" style="padding-bottom: 100%;">
                        <img src="//content.eventim.com/sc_f50ef/static/themes/responsive/integration/oeticket/images/elements/artistBlank.jpg"
                            alt="" role="presentation">
                    </picture>
                    <div class="leaf ta" v-if="item.isTicketAlarmEnabled">
                    </div>
                </div>
            </div>
            <div class="m-searchListItem__block">
                <h3 class="m-searchListItem__title  -artist">{{stripTags(item.title)}}</h3>
            </div>
            <div class="m-searchListItem__block">

            </div>
            <div class="m-searchListItem__block">
                <button v-translate="{ key: Translation.Show_more }" class="a-btnCta" type="button">Show more</button>
                <icon-component :icon-id="IconName.Chevron" class="m-searchListItem__iconCta"/>
            </div>
        </a>
    </li>
</template>

<style scoped>
</style>
